import { createFileRoute } from "@tanstack/react-router";

import { AiUsagePage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/ai-usage")({
  component: AiUsagePage,
});
